import { useStaticData } from "context/staticData";
import React from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";
import { CREATE_ID } from "shared/utils/constants";
import { useEntity } from "../context/entity";

export default function useInitAdminScreen(createKeyInParams: string = "") {
  const { navigateBack, navigate } = useNavigateWrapper();
  let params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { registrationId, eventSeriesId, programId } = useEntity();
  const location = useLocation();
  const staticData = useStaticData();

  const isCreateMode = params[createKeyInParams] === CREATE_ID || !params[createKeyInParams];

  const goBackToPreviousScreen = React.useCallback(() => {
    navigateBack();
  }, [navigateBack]);

  const navigateToCreate = React.useCallback(() => {
    navigate({ pathname: CREATE_ID, search: searchParams.toString() });
  }, [navigate, searchParams]);

  const navigateToIdByReplacingCreateInUrl = React.useCallback(
    (id: string, params?: string) => {
      navigate(
        {
          pathname: location.pathname.replace("create", id),
          search: params || searchParams.toString()
        },
        {
          replace: true
        }
      );
    },
    [location.pathname, navigate, searchParams]
  );

  return {
    navigate,
    navigateBack,
    params,
    registrationId,
    goBackToPreviousScreen,
    isCreateMode,
    searchParams,
    setSearchParams,
    navigateToCreate,
    eventSeriesId,
    staticData,
    navigateToIdByReplacingCreateInUrl,
    programId
  };
}
